import { TinyChannel } from '../../../types/channel.types';
import OverlayButton from '../../button/v2/overlay.button';
import Container from '../../containers/container';
import { TagsContainer } from '../../containers/tags.container';
import { ChannelDropdown } from '../../dropdown/channel.dropdown';
import Icon from '../../icons/icon';
import { HStack, VStack } from '../../layouts/stack.layout';
import Heading from '../../typography/v2/heading';
import Text from '../../typography/v2/text';
import Card from '../card';

const styles = {
  container:
    'rounded-lg relative cursor-pointer w-full mobile:h-[210px] tablet-sm:h-[300px] flex flex-col justify-between border-light-gray border',
  header: 'bg-black/75 backdrop-blur-xl h-[72.5%] rounded-t-md',
  footer:
    'bg-black/50 backdrop-blur-lg h-[27.5%] px-3 rounded-b-md overflow-hidden',
};

const smallCardStyles = {
  container: 'w-full h-full social-card overflow-hidden rounded-t-lg',
  body: 'bg-transparent h-full mobile:p-1.5 tablet-lg:py-6 tablet-lg:px-3 border-light-gray border-b overflow-hidden',
};

type Props = {
  channel: TinyChannel;
  onClick: Function;
};

/**
 * TODO: needs cleaning and updating for
 * mobile devices -- still a work in progress
 **/

export default function ChannelCard({ channel, onClick }: Props) {
  return (
    <Card
      backgroundImage={channel.backgroundImage}
      className={styles.container}
      onClick={() => onClick(channel)}
    >
      <Card.Header className={styles.header}>
        <Container extensions={smallCardStyles.container}>
          <Container extensions={smallCardStyles.body}>
            <HStack extensions="w-full h-full" gap="base">
              <Container
                extensions={'mobile:w-[100px] tablet-lg:w-[150px] h-full'}
              >
                <img
                  src={channel.backgroundImage}
                  alt={channel.title}
                  className="rounded-lg"
                  style={{ objectFit: 'cover', height: '100%', width: '100%' }}
                />
              </Container>
              <VStack extensions="tablet-lg:w-[calc(100%-150px)] mobile:w-[calc(100%-100px)] mobile:gap-3 tablet-lg:gap-8">
                <VStack extensions="w-full" gap="sm">
                  <HStack extensions="w-full items-center" justify="between">
                    <Heading variant="secondary">{channel.title}</Heading>
                    <ChannelDropdown id={channel.id || ''} />
                    <OverlayButton id={channel.id || ''} name="CHANNEL" />
                  </HStack>
                  <TagsContainer tags={channel.tags} />
                </VStack>
                <HStack extensions="w-full items-center h-[51px]" gap="sm">
                  <HStack extensions="relative w-[130px] items-center">
                    {channel.administrator && (
                      <div className="border-[3px] border-secondary rounded-full relative w-fit h-fit">
                        <img
                          key={channel.administrator.username}
                          src={channel.administrator.avatarUrl}
                          alt={channel.administrator.username}
                          style={{ objectFit: 'cover' }}
                          className="mobile:w-[30px] mobile:h-[30px] tablet-sm:w-[45px] tablet-sm:h-[45px] rounded-full"
                        />
                        <div className="absolute bottom-[-10px] rounded-full bg-secondary h-fit w-fit p-1">
                          <Icon icon="mic" size="xs" />
                        </div>
                      </div>
                    )}
                    {channel.topListners &&
                      channel.topListners.map((listener, index: number) => (
                        <img
                          key={listener.username}
                          src={listener.avatarUrl}
                          alt={listener.username}
                          style={{
                            objectFit: 'cover',
                            left: (index + 1) * 40 + 'px',
                            zIndex: 10,
                            position: 'absolute',
                          }}
                          className="mobile:w-[35px] mobile:h-[35px] tablet-sm:w-[50px] tablet-sm:h-[50px] rounded-full border-[3px] border-[#212528]"
                        />
                      ))}
                  </HStack>
                  <Container extensions="relative">
                    <Text variant="supplementary">
                      {channel.listenersCount} listeners
                    </Text>
                  </Container>
                </HStack>
              </VStack>
            </HStack>
          </Container>
        </Container>
      </Card.Header>
      <Card.Footer className={styles.footer}>
        <VStack extensions="w-full h-full justify-center">
          <Text variant="base">{channel.pinnedMessage}</Text>
        </VStack>
      </Card.Footer>
    </Card>
  );
}
